import React from 'react';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useLayoutStore } from 'stores/useLayoutStore';
import logo from 'assets/logo.svg';

/*
 * The compact top bar below md. Height is fixed at 3rem (h-12) — three routes subtract
 * exactly that from 100dvh to size their own scroll regions (Playlists/Container.jsx,
 * Settings.jsx, IdeasWrapper.jsx), so change it in all four places or none.
 *
 * Translucent + blurred to match the full-screen nav sheet the hamburger opens (Aside.jsx)
 * — the sheet's own top row is drawn at the same height and position, so opening the menu
 * reads as the bar expanding rather than a second panel appearing. It is a fixed row of the
 * app shell (Layout.jsx), not sticky: <main> scrolls, the document does not.
 */
export const MobileHeader = () => {
  const { t } = useTranslation();
  const { setSidebarCollapse, sidebarCollapse } = useLayoutStore();

  const handleToggle = () => {
    setSidebarCollapse(!sidebarCollapse);
  };

  return (
    <header className="relative z-10 flex h-12 flex-none items-center justify-between border-b border-ui-hair bg-ui-glass px-4 backdrop-blur-md md:hidden">
      <img src={logo} alt="" width={28} height={26} className="block" />
      <button
        onClick={handleToggle}
        className="-mr-2 flex h-10 w-10 items-center justify-center rounded-row text-ui-2 transition-colors duration-150 hover:bg-ui-overlay hover:text-ui focus:outline-none focus-visible:ring-2 focus-visible:ring-ui-accent-ring"
        type="button"
        aria-label={t(sidebarCollapse ? 'navBar.openNavigation' : 'navBar.closeNavigation')}
        aria-expanded={!sidebarCollapse}
        aria-controls="app-navigation"
      >
        <Menu size={22} />
      </button>
    </header>
  );
};
